import sanitizer from 'sanitize-html';

const defaultSanitizeOptions = {
    allowedAttributes: {
        ol: [
            'type'
        ],
        a: [
            'href'
        ]
    }
};
/**
 * Sanitize the given html string.
 */ const sanitizeHtml = (html, options)=>{
    return sanitizer(html, {
        ...defaultSanitizeOptions,
        ...options ? options(sanitizer) : {}
    });
};

export { defaultSanitizeOptions, sanitizeHtml };
//# sourceMappingURL=utils.es.js.map
